module.exports = __webpack_public_path__ + "static/img/printbg3.a74ff3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/report/printbg3.png
// module id = e3aN
// module chunks = 2